import { CommonModule } from '@angular/common'
import { Component, inject, input } from '@angular/core'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { RouterModule } from '@angular/router'
import { I18nText } from 'src/app/core/interfaces/i18n.service'
import { I18nService } from 'src/app/core/services/i18n.service'

@Component({
  selector: 'app-legal-terms',
  template: '<div class="container helper-text light-text-disabled" data-testid="legal-terms">{{i18n.get(terms())}}</div>',
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
  ],
})
export class LegalTermsComponent {
  protected i18n = inject(I18nService)

  terms = input<I18nText | string>('')
}
